<style scoped>
.tab {
  width: 100%;
  min-height: 48px;
  padding: 8px 16px 8px 16px;
}
.tab-active {
  border-top: 3px solid;
}
.mu-input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  min-height: 0px;
  font-size: 12px;
  width: auto;
}
.focus-text {
  font-size: 24px;
}
.table-empty {
  text-align: center;
}
</style>

<template>
  <mu-card>
    <mu-row>
      <mu-col 
        span="6" 
        class="tab tab-active" 
        :style="{ 'border-color': themePrimaryColor}"
        >
        <div><small>{{$t('AnalyticsNow.count')}}</small></div>
        <b class="focus-text">{{now}}</b>
      </mu-col>
    </mu-row>
    <chart 
      :option="bar" 
      id="AnalyticsNow" 
      height="100px" 
      />
    <mu-data-table :columns="columns" :data="list">
      <template slot-scope="scope">
        <td>
          <a :href="scope.row.route" target="_blank">
            {{scope.row.route}}
          </a>
        </td>
        <td>
          <b>{{scope.row.count}}</b>
        </td>
      </template>
      <template slot="empty">
        <div class="table-empty">
          <small>{{$t('AnalyticsNow.empty')}}</small>
        </div>
      </template>
    </mu-data-table>
  </mu-card>
</template>

<script>
import axios from "axios";

import theme from '@/mixins/theme.js'

import chart from '@/components/Charts/Charts.vue'
import echarts from 'echarts'

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

export default {
  props: ["channel"],
  mixins: [theme],
  components: {
  chart
  },
  data() {
    return {
      realtimedata: [],
      users: [],
      now: 0,
      
      interval: null,
    };
  },
  watch: {
    channel(newValue) {
      this.getData(newValue._id);
    },
  },
  computed: {
    bar() {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: true
          }
        },
        grid: {
          left: '5%',
          right: '5%',
          top: '0%',
          bottom: '10%'
        },
        xAxis: {
          type: "time",
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: this.themeTextColor
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: false
          },
          boundaryGap: [0, "100%"],
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: this.themeTextColor
            }
          },
          minInterval: 1
        },
        series: [
          {
            name: this.$t('AnalyticsNow.count'),
            type: "bar",
            showSymbol: false,
            hoverAnimation: false,
            data: this.realtimedata,
            itemStyle: {
              normal: {
                color: this.themePrimaryColor
              }
            }
          }
        ],
      };
    },
    columns(){
      return [
        { title: this.$t('AnalyticsNow.route'), name: 'route', sortable: false },
        { title: this.$t('AnalyticsNow.user'), name: 'count', sortable: false },
      ]
    },
    routes() {
      var arr = {};
      this.users.forEach(user => {
        if(arr.hasOwnProperty(user.route)) {
          arr[user.route]++;
        } else {
          arr[user.route] = 1;
        }
      });
      return arr;
    },
    list() {
      if(Object.keys(this.routes).length > 0) {
       return Object.keys(this.routes).map(key => {
        return {
          count: this.routes[key],
          route: key
        }
       });
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.getRealtime();
    this.update();
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  beforeDestroy() {
    window.clearInterval(this.interval);
  },
  methods: {
    getRealtime() {
      axios
        .get(this.$store.getters.urlApi + "analytics/now/channel/" + this.channel._id, {
          headers: {
            token: this.$store.state.auth.token
          }
        })
        .then(response => {
          this.realtimedata.push([Date.now(), response.data.data.count]);
          this.now = response.data.data.count;
          this.users = response.data.data.users;
        });
    },
    getRealTimeE() {
      this.getRealtime();
    },
    update() {
      this.interval = setInterval(this.getRealTimeE, 30000);
    },
  },
};
</script>
